import { Link } from 'react-router-dom'
import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import saveTime from '../../../../Imgs/Home/cocineros.svg'

function About() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <>
      <div className="bg-white">
        <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
          <div
            ref={ref}
            className="flex flex-col justify-between lg:flex-row items-center"
          >
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6 }}
              className="flex flex-col w-[90%] lg:w-[50%] mt-10 lg:mt-20"
            >
              <h1 className="text-left text-xl text-gray-700 md:text-4xl mx-[10px] font-bold tituloPrincipal">
                ¿Qué es <span className="text-Main">Pide y Pasa</span>?
              </h1>
              <p className="text-sm md:text-xl text-justify mt-5">
                Pide y Pasa es una plataforma digital innovadora de la categoría
                <b> FoodTech</b> enfocada exclusivamente en el sector de
                restaurantes. Su propósito es transformar y optimizar la gestión
                de pedidos, mejorando la experiencia de compra tanto para los
                restaurantes como para sus clientes.
              </p>
              <p className="text-sm md:text-xl text-justify mt-5">
                En general, está dirigida a cualquier negocio del sector
                gastronómico que desee modernizar su proceso de pedidos y
                ofrecer una experiencia más eficiente a sus clientes.
              </p>
              <Link to="/como-funciona" className="flex mt-10">
                <motion.button
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 1 }}
                  className="bg-Main mx-auto lg:mx-1 text-white w-[180px] h-[40px] rounded-3xl font-semibold "
                >
                  ¿Cómo funciona?
                </motion.button>
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex mt-7 lg:mt-0 lg:ml-8"
            >
              <img src={saveTime} height={500} width={312} alt="Save Time" />
            </motion.div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
